export default __webpack_public_path__ + "static/media/slider-smiles-1.8bb86bf4.jpg";